// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import { resolveDisplayAddress } from '../utils/resolveDisplayAddress'
const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  amber: '#B8721F', amberLight: '#D4902A', brown: '#2C1D14',
  muted: '#9A7B68', success: '#2E6B4A', danger: '#B03020',
}

const applianceIcons = {
  hvac: '🌬️', refrigerator: '❄️', water_heater: '🔥',
  washer: '👕', dryer: '🔌', dishwasher: '🍽️',
  oven: '🍳', microwave: '📡', garbage_disposal: '🗑️',
  smoke_detector: '🚨', garage_door: '🚗', other: '🔧',
}
const systemIcons = {
  septic: '🌿', solar: '☀️', pool: '🏊', well: '💧',
  propane: '🔥', generator: '⚡', battery: '🔋',
  sump_pump: '🌊', whole_house_fan: '💨', water_softener: '🚿',
  radiant_heat: '🌡️', electrical_panel: '🔌', adu: '🏠', other: '🔧',
}

const propertyTypeLabels = {
  single_family: 'Single Family Home', condo: 'Condo / Townhome',
  multi_family: 'Multi-Family', mobile: 'Mobile Home',
  vacation: 'Vacation Home', other: 'Property',
}

const maintenanceSchedules = {
  hvac: [
    { task: 'Filter Replacement', interval: 'Every 90 days', type: 'auto_order' },
    { task: 'Coil Cleaning', interval: 'Annually — Spring', type: 'contractor' },
    { task: 'Full System Inspection', interval: 'Annually — Fall', type: 'contractor' },
  ],
  refrigerator: [
    { task: 'Water Filter Replacement', interval: 'Every 6 months', type: 'auto_order' },
    { task: 'Condenser Coil Cleaning', interval: 'Annually', type: 'diy' },
    { task: 'Door Seal Inspection', interval: 'Annually', type: 'diy' },
  ],
  water_heater: [
    { task: 'Tank Flush & Sediment Drain', interval: 'Annually', type: 'diy' },
    { task: 'Anode Rod Inspection', interval: 'Every 2 years', type: 'contractor' },
    { task: 'Pressure Relief Valve Test', interval: 'Annually', type: 'diy' },
  ],
  washer: [
    { task: 'Drum Cleaning Cycle', interval: 'Monthly', type: 'diy' },
    { task: 'Door Gasket Wipe Down', interval: 'Monthly', type: 'diy' },
    { task: 'Inlet Hose Inspection', interval: 'Annually', type: 'diy' },
  ],
  dryer: [
    { task: 'Lint Trap Cleaning', interval: 'Every use', type: 'diy' },
    { task: 'Vent Duct Cleaning', interval: 'Annually', type: 'contractor' },
    { task: 'Exterior Vent Check', interval: 'Every 6 months', type: 'diy' },
  ],
  dishwasher: [
    { task: 'Filter Cleaning', interval: 'Monthly', type: 'diy' },
    { task: 'Spray Arm Cleaning', interval: 'Every 3 months', type: 'diy' },
    { task: 'Descaling Treatment', interval: 'Every 6 months', type: 'auto_order' },
  ],
  smoke_detector: [
    { task: 'Battery Replacement', interval: 'Annually', type: 'auto_order' },
    { task: 'Test & Inspection', interval: 'Monthly', type: 'diy' },
    { task: 'Full Replacement', interval: 'Every 10 years', type: 'auto_order' },
  ],
  garage_door: [
    { task: 'Lubricate Moving Parts', interval: 'Every 6 months', type: 'auto_order' },
    { task: 'Safety Sensor Test', interval: 'Monthly', type: 'diy' },
    { task: 'Full Service Inspection', interval: 'Annually', type: 'contractor' },
  ],
  oven: [
    { task: 'Deep Clean', interval: 'Every 3 months', type: 'diy' },
    { task: 'Burner Inspection', interval: 'Annually', type: 'diy' },
  ],
  microwave: [
    { task: 'Interior Clean', interval: 'Monthly', type: 'diy' },
    { task: 'Filter Replacement', interval: 'Every 6 months', type: 'auto_order' },
  ],
  garbage_disposal: [
    { task: 'Cleaning & Deodorizing', interval: 'Monthly', type: 'auto_order' },
    { task: 'Blade Inspection', interval: 'Annually', type: 'diy' },
  ],
  other: [{ task: 'General Inspection', interval: 'Annually', type: 'diy' }],
}

const S = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(44,29,20,0.5)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 2000, padding: '20px', fontFamily: 'Georgia, serif',
  },
  modal: {
    background: C.card, borderRadius: '16px', width: '100%',
    maxWidth: '680px', maxHeight: '90vh', overflowY: 'auto',
    boxShadow: '0 8px 40px rgba(44,29,20,0.2)', border: `1px solid ${C.border}`,
  },
  header: {
    padding: '24px 28px', display: 'flex',
    justifyContent: 'space-between', alignItems: 'center',
    borderBottom: `1px solid ${C.border}`,
    position: 'sticky', top: 0, background: C.card, zIndex: 10,
  },
  title: { fontSize: '20px', fontWeight: '700', color: C.brown },
  headerActions: { display: 'flex', gap: '10px', alignItems: 'center' },
  printBtn: {
    background: `linear-gradient(135deg, ${C.amber}, ${C.amberLight})`,
    border: 'none', borderRadius: '8px', padding: '9px 18px',
    color: C.card, fontSize: '12px', fontWeight: '700',
    letterSpacing: '1px', textTransform: 'uppercase',
    cursor: 'pointer', fontFamily: 'Georgia, serif',
  },
  closeBtn: {
    background: 'none', border: 'none', fontSize: '22px',
    cursor: 'pointer', color: C.muted, padding: '0', lineHeight: 1,
  },
  printArea: { padding: '28px' },
  // Print-specific header
  printHeader: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
    marginBottom: '24px', paddingBottom: '20px', borderBottom: `2px solid ${C.amber}`,
  },
  printLogo: {
    fontSize: '22px', fontWeight: '700', color: C.amber, letterSpacing: '4px',
  },
  printAddress: { fontSize: '13px', color: C.muted, fontFamily: 'Calibri, sans-serif', marginTop: '4px' },
  printDate: { fontSize: '12px', color: C.muted, fontFamily: 'Calibri, sans-serif', textAlign: 'right' },
  sectionTitle: {
    fontSize: '11px', color: C.muted, letterSpacing: '2px',
    textTransform: 'uppercase', marginBottom: '10px',
    fontFamily: 'Calibri, sans-serif', fontWeight: '700',
    paddingBottom: '6px', borderBottom: `1px solid ${C.border}`,
  },
  section: { marginBottom: '24px' },
  profileGrid: {
    display: 'grid', gridTemplateColumns: '1fr 1fr 1fr',
    gap: '8px', marginBottom: '4px',
  },
  profileItem: {
    background: C.bg, borderRadius: '8px', padding: '10px 12px',
    border: `1px solid ${C.border}`,
  },
  profileLabel: {
    fontSize: '9px', color: C.muted, letterSpacing: '1px',
    textTransform: 'uppercase', fontFamily: 'Calibri, sans-serif', marginBottom: '2px',
  },
  profileValue: { fontSize: '13px', fontWeight: '600', color: C.brown },
  applianceRow: {
    display: 'flex', alignItems: 'flex-start', gap: '12px',
    padding: '12px 0', borderBottom: `1px solid ${C.border}`,
  },
  applianceIcon: { fontSize: '20px', flexShrink: 0, marginTop: '2px' },
  applianceName: { fontSize: '14px', fontWeight: '700', color: C.brown },
  applianceMeta: { fontSize: '12px', color: C.muted, fontFamily: 'Calibri, sans-serif', marginTop: '1px' },
  applianceTasks: { marginTop: '6px' },
  taskPill: (type) => {
    const colors = {
      auto_order: { bg: '#FBF3E8', color: C.amber },
      contractor: { bg: '#EBF5EF', color: C.success },
      diy: { bg: C.bg, color: C.muted },
    }
    const c = colors[type] || colors.diy
    return {
      display: 'inline-block', fontSize: '10px', padding: '2px 8px',
      borderRadius: '20px', background: c.bg, color: c.color,
      fontFamily: 'Calibri, sans-serif', border: `1px solid ${c.color}33`,
      marginRight: '4px', marginBottom: '4px',
    }
  },
  footer: {
    marginTop: '24px', paddingTop: '16px', borderTop: `1px solid ${C.border}`,
    fontSize: '11px', color: C.muted, fontFamily: 'Calibri, sans-serif',
    textAlign: 'center',
  },
}

export default function PrintSummary({ profile, appliances, systems, onClose }) {
  const address = resolveDisplayAddress(profile, true) || 'Address not set'
  const propertyType = profile?.property_type
    ? propertyTypeLabels[profile.property_type] : ''
  const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })

  const handlePrint = () => {
    const printContents = document.getElementById('casavio-print-area').innerHTML
    const win = window.open('', '_blank')
    win.document.write(`
      <html>
      <head>
        <title>Casavio Home Summary — ${address}</title>
        <style>
          * { box-sizing: border-box; margin: 0; padding: 0; }
          body { font-family: Georgia, serif; color: #2C1D14; background: white; padding: 32px; font-size: 13px; }
          h1 { font-size: 22px; color: #B8721F; letter-spacing: 4px; }
          h2 { font-size: 11px; text-transform: uppercase; letter-spacing: 2px; color: #9A7B68; font-family: Calibri, sans-serif; border-bottom: 1px solid #DDD4C6; padding-bottom: 6px; margin: 20px 0 10px; }
          .header { display: flex; justify-content: space-between; margin-bottom: 24px; padding-bottom: 16px; border-bottom: 2px solid #B8721F; }
          .grid3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 8px; margin-bottom: 8px; }
          .box { background: #F2EDE4; border: 1px solid #DDD4C6; border-radius: 6px; padding: 8px 10px; }
          .box-label { font-size: 9px; text-transform: uppercase; letter-spacing: 1px; color: #9A7B68; font-family: Calibri, sans-serif; }
          .box-val { font-size: 13px; font-weight: 700; }
          .app-row { display: flex; gap: 10px; padding: 10px 0; border-bottom: 1px solid #DDD4C6; }
          .app-name { font-size: 13px; font-weight: 700; }
          .app-meta { font-size: 11px; color: #9A7B68; font-family: Calibri, sans-serif; }
          .pill { display: inline-block; font-size: 10px; padding: 1px 7px; border-radius: 20px; font-family: Calibri, sans-serif; margin: 2px 3px 2px 0; }
          .pill-diy { background: #F2EDE4; color: #9A7B68; }
          .pill-contractor { background: #EBF5EF; color: #2E6B4A; }
          .pill-auto { background: #FBF3E8; color: #B8721F; }
          .footer { margin-top: 24px; padding-top: 12px; border-top: 1px solid #DDD4C6; font-size: 10px; color: #9A7B68; font-family: Calibri, sans-serif; text-align: center; }
          @media print { body { padding: 16px; } }
        </style>
      </head>
      <body>${printContents}</body>
      </html>
    `)
    win.document.close()
    win.focus()
    setTimeout(() => { win.print(); win.close() }, 300)
  }

  return (
    <div style={S.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={S.modal}>
        <div style={S.header}>
          <div style={S.title}>📄 Home Summary</div>
          <div style={S.headerActions}>
            <button style={S.printBtn} onClick={handlePrint}>🖨️ Print / Save PDF</button>
            <button style={S.closeBtn} onClick={onClose}>×</button>
          </div>
        </div>

        <div style={S.printArea}>
          <div id="casavio-print-area">

            {/* Print header */}
            <div style={S.printHeader}>
              <div>
                <div style={S.printLogo}>CASAVIO</div>
                <div style={S.printAddress}>{address}</div>
                {propertyType && <div style={{ ...S.printAddress, marginTop: '2px' }}>{propertyType}</div>}
              </div>
              <div style={S.printDate}>
                <div style={{ fontWeight: '700', color: C.brown }}>Home Summary Report</div>
                <div style={{ marginTop: '4px' }}>{today}</div>
              </div>
            </div>

            {/* Property details */}
            <div style={S.section}>
              <div style={S.sectionTitle}>Property Details</div>
              <div style={S.profileGrid}>
                {[
                  ['Year Built', profile?.year_built || '—'],
                  ['Bedrooms', profile?.bedrooms || '—'],
                  ['Bathrooms', profile?.bathrooms || '—'],
                  ['Sq. Footage', profile?.sqft ? `${parseInt(profile.sqft).toLocaleString()} sq ft` : '—'],
                  ['Property Type', propertyType || '—'],
                  ['City / State', profile?.city ? `${profile.city}, ${profile.state}` : '—'],
                ].map(([label, value]) => (
                  <div key={label} style={S.profileItem}>
                    <div style={S.profileLabel}>{label}</div>
                    <div style={S.profileValue}>{value}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Appliances */}
            {appliances.length > 0 && (
              <div style={S.section}>
                <div style={S.sectionTitle}>Appliances ({appliances.length})</div>
                {appliances.map((a, i) => {
                  const schedule = maintenanceSchedules[a.type] || maintenanceSchedules.other
                  return (
                    <div key={i} style={S.applianceRow}>
                      <div style={S.applianceIcon}>{applianceIcons[a.type] || '🔧'}</div>
                      <div style={{ flex: 1 }}>
                        <div style={S.applianceName}>{a.nickname || a.name}</div>
                        <div style={S.applianceMeta}>
                          {a.make} {a.model}
                          {a.serial ? ` · S/N: ${a.serial}` : ''}
                          {a.manufactured ? ` · ${a.manufactured}` : ''}
                          {a.location ? ` · 📍 ${a.location}` : ''}
                        </div>
                        <div style={S.applianceTasks}>
                          {schedule.map((task, j) => (
                            <span key={j} style={S.taskPill(task.type)}>
                              {task.task} — {task.interval}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            )}

            {/* Systems */}
            {systems.length > 0 && (
              <div style={S.section}>
                <div style={S.sectionTitle}>Home Systems ({systems.length})</div>
                {systems.map((s, i) => (
                  <div key={i} style={S.applianceRow}>
                    <div style={S.applianceIcon}>{systemIcons[s.type] || '🔧'}</div>
                    <div style={{ flex: 1 }}>
                      <div style={S.applianceName}>{s.name}</div>
                      <div style={S.applianceMeta}>
                        {s.manufacturer ? s.manufacturer : ''}
                        {s.model ? ` ${s.model}` : ''}
                        {s.installed_year ? ` · Installed ${s.installed_year}` : ''}
                        {s.last_serviced ? ` · Last serviced: ${s.last_serviced}` : ''}
                      </div>
                      {s.notes && (
                        <div style={{ fontSize: '11px', color: C.muted, fontFamily: 'Calibri, sans-serif', marginTop: '4px', fontStyle: 'italic' }}>
                          {s.notes}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Footer */}
            <div style={S.footer}>
              Generated by Casavio — Your home deserves to be managed like the asset it is. · casavio.com
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}